"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var Cache = /*#__PURE__*/ function() {
    "use strict";
    function Cache(name, formatter) {
        _classCallCheck(this, Cache);
        this.name = name;
        this.cache = new Map();
        this.formatter = formatter || function(input) {
            return input;
        };
    }
    var _proto = Cache.prototype;
    _proto.set = function set(key, value) {
        value = this.formatter(value);
        this.cache.set(key, value);
        return value;
    };
    _proto.get = function get(key) {
        return this.cache.get(key);
    };
    _proto.delete = function _delete(key) {
        this.cache.delete(key);
    };
    _proto.clear = function clear() {
        this.cache.clear();
    };
    Cache.getInstance = function getInstance(name, formatter) {
        var instance = Cache.instance.get(name);
        if (!instance) {
            instance = new Cache(name, formatter);
            Cache.instance.set(name, instance);
        }
        return instance;
    };
    return Cache;
}();
Cache.instance = new Map();
var _default = Cache;
exports.default = _default;
